import React, { Component } from 'react'
import _ from 'lodash'
import { AutoSizer, BooleanCell, InputCell, Table, FailureIndicator } from './DataTable'
import { defaultTableHeaderRowRenderer } from 'react-virtualized';
import DatePicker from '../components/Calendar/DatePicker'
import { Select } from '../components/Form'
import {
    defaultRowRenderer,
    Column, defaultHeaderRenderer
} from 'react-virtualized/dist/commonjs/Table'
import ValidationUI from './ValidationUI'
import {makeDataGetter, getEditStartDateById, getEditEndDateById, getListOptions} from '../apps/KpModule/selectors'
import './DtObjectsComponent.css'
import DownloadDataTable from './DataTable/DownloadDataTable'
import DataTableFilter from './DataTable/DataTableFilter'
import { applyFilter, applySort } from './DataTable/DataTable'
import ColumnSelector from './DataTable/ColumnSelector'
import HoverPopover from "./HoverPopover";
import {setFieldWidth, toggleCalendar} from '../apps/KpModule/actions'
import {getModuleIdFromPath, mergeModuleFilters} from '../apps/KpModule/filterStorage'
import {connect} from "react-redux";
import {HEADER_HEIGHT, ROW_HEIGHT} from "./DataTable/Table";
import moment from "moment";
import Draggable from "react-draggable";
import CheckboxField from "./Form/CheckboxField";
import {translateName} from "../utils/i18n";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Table as TableIcon, AreaChart, BarChart as BarChartIcon, LineChart as LineChartIcon } from 'lucide-react';

const tableHeightForRows = nRows => ROW_HEIGHT * nRows


const getFormattedAmount = (amount, language) => {
    const parsed = parseFloat(amount)
    if(parsed) return new Intl.NumberFormat(language, {minimumFractionDigits: 2}).format(parsed)
}


const DATE_FORMAT = 'YYYY-MM-DD'

function dateComparator(startDate, endDate) {
    if (!startDate && !startDate) return

    const referenceStartDate = startDate && moment(startDate, DATE_FORMAT).startOf('day')
    const referenceEndDate = endDate && moment(endDate, DATE_FORMAT).startOf('day')

    return function compareDate(date) {
        return date
            ? startDate && endDate
                ? moment(referenceStartDate).diff(date.startOf('day'), 'days')  > 0 || moment(referenceEndDate).diff(date.startOf('day'), 'days')  < 0
                : startDate
                    ? moment(referenceStartDate).diff(date.startOf('day'), 'days')  > 0
                    : moment(referenceEndDate).diff(date.startOf('day'), 'days')  < 0
            : false
    }
}


class DtObjectsComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewMode: 'table',
            graphType: 'barchart',
            sortBy: props.defaultSortBy,
            sortDirection: props.defaultSortDirection || 'ASC',
            filter: '',
            isSearchActive: false,
            columnSelectorOpened: false,
            selectorOptions: props.listFields
                .map(column => ({
                    key: column.path,
                    label: column.tKey,
                    selected: !column.initiallyNotVisible
                })),
            openById: {},
            startDateById: {},
            endDateById: {}
        }
        this.cellRenderer = this.cellRenderer.bind(this)
        this.headerRenderer = this.headerRenderer.bind(this)
        this.renderColumnHeader = this.renderColumnHeader.bind(this)
        this.renderGraphView = this.renderGraphView.bind(this)
    }

    componentDidUpdate(prevProps, prevState) {
        let newColumnDetected = false
        const selectorOptions = this.props.listFields.map(column => {
            const prevOptionData = prevState.selectorOptions.find(option => option.key === column.path)
            if(!prevOptionData) {
                newColumnDetected = true
                return {
                    key: column.path,
                    label: column.tKey,
                    selected: !column.initiallyNotVisible
                }
            }
            return {
                key: column.path,
                label: column.tKey,
                selected: prevOptionData.selected
            }
        })

        if(newColumnDetected) {
            this.setState({
                selectorOptions
            })
        }
    }

    cellRenderer(sortedObjects, field, onChange, parentFieldDisabled) {
        const {startDateById, endDateById, groupModel, language, t} = this.props
        switch (field.type) {
            case 'object':
                return ({ cellData }) => {
                    const display = field.display
                    const value = cellData && typeof cellData === 'object'
                        ? display
                            ? cellData[display]
                            : cellData.name || cellData.fullName
                        : cellData
                    return <div>{value}</div>
                }
            case 'checkbox':
                return ({ rowData, cellData, dataKey }) => (
                    <CheckboxField
                        disabled={parentFieldDisabled || field.disabled}
                        value={cellData}
                        onChange={() => {
                            const newRowData = {[dataKey]: !cellData}
                            onChange({ [rowData.id]: newRowData })
                        }}
                    />
                )
            case "dropdownObject":
                const originalOptionsById = field.customOptions.reduce((acc, option) => {
                    return {
                        ...acc,
                        [option.id]: option
                    }
                }, {})
                const optionsById = field.customOptions.reduce((acc, option) => {
                    const display = _.get(option, field.display)
                    return {
                        ...acc,
                        [option.id]: {
                            value: option.id,
                            label: field.translateName
                                ? translateName(display, language)
                                : field.translate
                                    ? t(display)
                                    : display
                        }
                    }},{})
                const selectOptions = field.customOptions.map(option => optionsById[option.id])
                return ({ rowData, cellData, dataKey }) => {
                    const value = cellData?.id && optionsById[cellData.id]
                    return <Select
                        value={value}
                        onChange={option => {
                            const newRowData = {[dataKey]: option?.value ? originalOptionsById[option.value] : null}
                            onChange({ [rowData.id]: newRowData })
                        }}
                        options={selectOptions}
                        menuPortalTarget={document.body}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: '32px',
                                height: '32px',
                                marginTop: '2px',
                                padding: '0 4px',
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                padding: '0 4px',
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: '32px',
                            }),
                        }}
                        multi={false}
                        isClearable={true}
                        isDisabled={false}
                        t={t}
                    />
                }
            case 'datePicker':
                return ({ rowData, cellData, dataKey }) => {
                    const startDate = startDateById[`${field.id}-${rowData.id}`]
                    const endDate = endDateById[`${field.id}-${rowData.id}`]
                    const comparator = dateComparator(startDate, endDate)
                    return (
                        <DatePicker
                            value={cellData}
                            style={field.style}
                            open={this.state.openById[`${field.id}-${rowData.id}`]}
                            disabled={parentFieldDisabled || field.disabled}
                            onOpenChange={() => this.setState({
                                openById: {
                                    ...this.state.openById,
                                    [`${field.id}-${rowData.id}`] : !this.state.openById[`${field.id}-${rowData.id}`]
                                }
                            })}
                            onChange={value => {
                                const newRowData = {[dataKey]: value}
                                onChange({ [rowData.id]: newRowData })
                            }}
                            disabledDate={comparator}
                            dtObject={true}
                        />
                    )
                }
            case 'editText':
                if(parentFieldDisabled || field.disabled) return ({ rowData, dataKey }) => <div>{_.get(rowData, dataKey)}</div>
                return ({ rowIndex, rowData, dataKey }) => {
                    if(!!rowData._disabled) return <div>{_.get(rowData, dataKey)}</div>
                    const cellData = _.get(rowData, dataKey)

                    const shallowPath = dataKey.split('.')[0]
                    const deepPath = dataKey.split('.')[1]

                    return (
                        <InputCell
                            value={cellData}
                            type={field.inputType}
                            onPaste={ event => {
                                if(deepPath) {
                                    event.preventDefault()

                                    const paste = (event.clipboardData || window.clipboardData).getData('text');
                                    const result = paste.split('\n');
                                    const result2 = []
                                    result.forEach(row => result2.push(row.split('\t')))

                                    const changes = {}
                                    let currentRowIndex = rowIndex
                                    result2.forEach(pastedRow => {
                                        const currentRow = sortedObjects[currentRowIndex]
                                        if(!currentRow) return
                                        if(!deepPath) {
                                            changes[currentRow.id] = {
                                                [field.path]: {
                                                    ...currentRow[field.path],
                                                    data: pastedRow[0]
                                                }
                                            }
                                        } else {
                                            const dynamicFieldKeys = Object.keys(currentRow[shallowPath])

                                            let currentCellIndex = dynamicFieldKeys.indexOf(deepPath)
                                            const newDynamicFieldData = pastedRow.reduce((acc, pastedCell) => {
                                                if(!dynamicFieldKeys[currentCellIndex]) return acc
                                                const object = {
                                                    ...acc,
                                                    [dynamicFieldKeys[currentCellIndex]]: pastedCell
                                                }
                                                currentCellIndex++
                                                return object
                                            }, {})
                                            changes[currentRow.id] = {
                                                [shallowPath]: {
                                                    ...currentRow[shallowPath],
                                                    ...newDynamicFieldData
                                                }
                                            }
                                        }
                                        currentRowIndex++
                                    })

                                    onChange(changes)
                                }

                            }}
                            onChange={event => {

                                const newRowData = deepPath
                                    ? {
                                        [shallowPath]: {
                                            ...rowData[shallowPath],
                                            [deepPath]: event.target.value
                                        }
                                    }
                                    : {
                                        [shallowPath]: event.target.value
                                    }

                                onChange({ [rowData.id]: newRowData })
                            }}
                        />
                    )
                }
            case 'boolean':
                return ({ cellData }) => <BooleanCell value={cellData} />
            case 'dateString':
                return ({ cellData }) => {
                    return cellData ? moment(cellData).format(field.dateFormat) : null
                }
            case 'failureIndicator':
                return ({ cellData }) => <FailureIndicator value={cellData} />
            case 'links':
                return ({ rowData, dataKey }) => {
                    const cellData = _.get(rowData, dataKey)
                    return (
                        <div style={{display: 'flex', flexDirection: 'row'}}>
                            {cellData && cellData.map((link, index) => <div style={{display: 'flex', flexDirection: 'row'}}>
                                {index !== 0 && <div className="DtObjectsComponent-Link-separator"> {" | "}</div>}
                                <div
                                    className="DtObjectsComponent-Link"
                                    onClick={() => {
                                        if(link.query) {
                                            // pre-fill the filters of the module opened in the new tab
                                            mergeModuleFilters(getModuleIdFromPath(link.path), link.query)
                                            window.open(`${window.location.origin}/business/${groupModel.id}${link.path}`)
                                        }
                                    }}
                                >
                                    {link.name}
                                </div>
                            </div>)}
                        </div>
                    )
                }
            case 'customized':
                return ({ rowIndex, rowData, dataKey }) => {
                    const cellData = _.get(rowData, dataKey)
                    switch (cellData.type) {
                        case 'checkbox':
                            return (
                                <CheckboxField
                                    disabled={parentFieldDisabled || field.disabled || !!cellData.disabled}
                                    value={cellData.data}
                                    onChange={() => {
                                        const newRowData = {
                                            [dataKey]: {
                                                ...cellData,
                                                data: !cellData.data
                                            }
                                        }
                                        onChange({ [rowData.id]: newRowData })
                                    }}
                                />
                            )
                        case 'datePicker':
                            return (
                                <DatePicker
                                    value={cellData.data}
                                    style={field.style}
                                    open={this.state.openById[`${field.id}-${rowData.id}`]}
                                    disabled={parentFieldDisabled || field.disabled}
                                    onOpenChange={() => this.setState({
                                        openById: {
                                            ...this.state.openById,
                                            [`${field.id}-${rowData.id}`] : !this.state.openById[`${field.id}-${rowData.id}`]
                                        }
                                    })}
                                    onChange={value => {
                                        const newRowData = {
                                            [dataKey]: {
                                                ...cellData,
                                                data: value
                                            }
                                        }
                                        onChange({ [rowData.id]: newRowData })
                                    }}
                                    dtObject={true}
                                />
                            )
                        case 'editText':
                            const shallowPath = field.path.split('.')[0]
                            const deepPath = field.path.split('.')[1]
                            if(parentFieldDisabled || field.disabled) return <div style={cellData.style}>{cellData.data}</div>
                            return (
                                <InputCell
                                    style={cellData.style}
                                    value={cellData.data}
                                    onPaste={ event => {
                                        if(deepPath) {
                                            event.preventDefault()

                                            const paste = (event.clipboardData || window.clipboardData).getData('text');
                                            const result = paste.split('\n');
                                            const result2 = []
                                            result.forEach(row => result2.push(row.split('\t')))

                                            const changes = {}
                                            let currentRowIndex = rowIndex
                                            result2.forEach(pastedRow => {
                                                const currentRow = sortedObjects[currentRowIndex]
                                                if(!currentRow) return
                                                if(!deepPath) {
                                                    const currentCell = currentRow[field.path]
                                                    if(currentCell.type || currentCell.type === 'editText') {
                                                        changes[currentRow.id] = {
                                                            [field.path]: {
                                                                ...currentCell,
                                                                data: pastedRow[0]
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    const dynamicFieldKeys = Object.keys(currentRow[shallowPath])

                                                    let currentCellIndex = dynamicFieldKeys.indexOf(deepPath)
                                                    const newDynamicFieldData = pastedRow.reduce((acc, pastedCell) => {
                                                        if(!dynamicFieldKeys[currentCellIndex]) return acc
                                                        const currentCell = currentRow[shallowPath][dynamicFieldKeys[currentCellIndex]]
                                                        if(!currentCell.type || currentCell.type !== 'editText') return acc
                                                        const object = {
                                                            ...acc,
                                                            [dynamicFieldKeys[currentCellIndex]]: {
                                                                ...currentCell,
                                                                data: pastedCell
                                                            }
                                                        }
                                                        currentCellIndex++
                                                        return object
                                                    }, {})
                                                    changes[currentRow.id] = {
                                                        [shallowPath]: {
                                                            ...currentRow[shallowPath],
                                                            ...newDynamicFieldData
                                                        }
                                                    }
                                                }
                                                currentRowIndex++
                                            })
                                            onChange(changes)
                                        }

                                    }}
                                    onChange={event => {
                                        const newRowData = deepPath
                                            ? {
                                                [shallowPath]: {
                                                    ...rowData[shallowPath],
                                                    [deepPath]: {
                                                        ...cellData,
                                                        data: event.target.value
                                                    }
                                                }
                                            }
                                            : {
                                                [shallowPath]: {
                                                    ...rowData[shallowPath],
                                                    data: event.target.value
                                                }
                                            }

                                        onChange({ [rowData.id]: newRowData })
                                    }}
                                />
                            )
                        case 'boolean':
                            return <BooleanCell value={cellData.data} />
                        /*
                        case 'boolean':
                            return ({ cellData }) => (
                                <div>{cellData.data ? 'TRUE': 'FALSE'}</div>
                            )
                         */
                        case 'amount':
                            return <div style={{textAlign: 'end'}}>{getFormattedAmount(cellData.data, language)}</div>
                        case 'number':
                            return <div style={{textAlign: 'end'}}>{cellData.data}</div>
                        default:
                            return cellData && _.has(cellData, 'data') ? (
                                <div style={cellData.style}>
                                    {cellData.data?.toString()}
                                </div>
                            ) : (
                                <div>{cellData?.toString()}</div>
                            )
                    }
                }
            default:
                return ({ cellData }) => {
                    const value = cellData && typeof cellData === 'object' ? cellData.name || cellData.fullName || '' : cellData
                    const translated = field.translate ? t(value) : value
                    return <div>{translated}</div>
                }
        }
    }

    changeFilter(filter) {
        this.setState({filter})
    }

    handleOpenColumnSelector = ({ opened }) => {
        this.setState({
            columnSelectorOpened: opened
        })
    }

    handleChangeColumnSelection({ key, selected }) {
        const selectorOptions = this.state.selectorOptions.map(option => {
            return option.key === key ? { ...option, selected } : option
        })

        this.setState({selectorOptions})
    }

    headerRenderer(props, selectedColumns, parentHeader) {
        const {style} = props
        const groupedByParent = _.groupBy(selectedColumns, 'parentColumn')
        const parentColumns = Object.keys(groupedByParent).map(key => {
            return groupedByParent[key].reduce((acc, column) => {
                acc.width += column.width
                acc.nb++
                return acc
            }, { path: key, width: 0, nb: 0 })
        })
        return parentHeader
            ? (
                <div>
                    <div className='DataTable-Table-parent-headerRow' style={{...style, borderBottom: '1px solid #adb0ba'}}>
                        {parentColumns.map((column, index) => <div style={{
                            flex: `${column.nb} ${column.width}px`,
                            fontWeight: 'bold',
                            fontSize: '14px',
                            marginTop: '10px',
                            marginRight: `${10 * column.nb}px`,
                            textTransform: 'none',
                            outline: 'none',
                            marginLeft: index ? '0' : '10px',
                        }}>
                            {column.path}
                        </div>)}
                    </div>
                    {defaultTableHeaderRowRenderer(props)}
                </div>
            )
            : defaultTableHeaderRowRenderer(props)

    }

    renderColumnHeader = (column, nextColumn, sortedObjects, onChange) => {
        const {objects = [], setFieldWidth, t} = this.props

        return headerParams => {
            const getNumber = o => {
                const numberCandidate = Number(_.get(o, column.path))
                return _.isNaN(numberCandidate) ? 0 : numberCandidate
            }
            const total = _.round(
                objects.reduce((acc, o) => getNumber(o) + acc, 0)
            )

            const headerRenderer = defaultHeaderRenderer(headerParams)

            let children = []

            if (column.tooltip) {
                children.push(
                    <HoverPopover
                        key="overlay"
                        id={'KpDataTable-tooltip'}
                        message={`${t('total')} : ${total}`}
                        placement={'top'}
                    >
                        {headerRenderer[0]}
                    </HoverPopover>
                )
            } else if(column.enableSelectAll) {
                const allObjectsSelected = sortedObjects.every(object => !!object[column.path])
                children.push(
                    <div onClick={event => event.stopPropagation()}>
                        <CheckboxField
                            value={allObjectsSelected}
                            onChange={() => {

                                const changes = sortedObjects.reduce((acc, object) => ({
                                    ...acc,
                                    [object.id]: {
                                        [column.path]: !allObjectsSelected
                                    }
                                }), {})

                                onChange(changes)

                            }}
                        />
                    </div>
                )
            } else {
                children.push(headerRenderer[0])
            }


            // the second element is the sort indicator
            if (headerRenderer[1]) {
                children.push(headerRenderer[1])
            }

            if(nextColumn) {
                children.push(
                    <div
                        onClick={event => event.stopPropagation()}
                    >
                        <Draggable
                            axis="x"
                            defaultClassName="DragHandle"
                            defaultClassNameDragging="DragHandleActive"
                            onDrag={(event, data) => {
                                const delta = data.deltaX;
                                const columnWidth = column.width + delta
                                const nextColumnWidth = nextColumn.width - delta

                                setFieldWidth(column.id, columnWidth)
                                setFieldWidth(nextColumn.id, nextColumnWidth)
                            }}
                            position={{ x: 0 }}
                            zIndex={999}
                        >
                            <span className="DragHandleIcon">⋮</span>
                        </Draggable>
                    </div>
                )
            }
            return children
        }
    }

    computeHeight = objects => {
        const {field: {maxRows, autoGrow, disableHeader, headerHeight}} = this.props

        const finalHeaderHeight = disableHeader
            ? 0
            : headerHeight || HEADER_HEIGHT

        const totalHeight = tableHeightForRows(objects.length)
        if (autoGrow) return totalHeight + finalHeaderHeight

        const maxHeight = maxRows && tableHeightForRows(maxRows)

        const height = maxRows ? Math.min(totalHeight, maxHeight) : totalHeight

        // the max is to ensure we see at least one line to show the no row message
        return Math.max(
            height + finalHeaderHeight,
            HEADER_HEIGHT + ROW_HEIGHT
        )
    }

    getHeight = objects => this.props.height || this.computeHeight(objects)

    onRowChange = (newValues) => {
        const {field, input: {value, onChange}, touch} = this.props

        touch(field.path)

        const allIds = value.map(value => value.id)
        const byId = value.reduce((acc, value) => ({...acc, [value.id]: value}), {})

        onChange(
            allIds.map(id => {
                if(newValues[id]) {
                    return {
                        ...byId[id],
                        ...newValues[id]
                    }
                }
                return byId[id]
            })
        )
    }

    renderGraphView(data) {
        const { listFields, t, field } = this.props;
        const { graphXAxisKey, graphYAxisKey, graphHeight } = field;
        const { graphType } = this.state;

        if (!graphXAxisKey || !graphYAxisKey) {
            return <div style={{padding: '20px', textAlign: 'center', border: '1px solid #ddd', borderRadius: '4px'}}>Graph view is not configured. Please provide 'graphXAxisKey' and 'graphYAxisKey' props in the field definition.</div>;
        }

        if (!data || data.length === 0) {
            return <div style={{padding: '20px', textAlign: 'center'}}>No data to display for the graph.</div>;
        }

        const yAxisField = listFields.find(f => f.path === graphYAxisKey);

        // Group and aggregate data
        const groupedData = _.groupBy(data, graphXAxisKey);
        const chartData = _.map(groupedData, (group, key) => {
            const aggregatedRow = { [graphXAxisKey]: key };
            const firstItem = group[0];
            const yAxisSampleData = _.get(firstItem, graphYAxisKey);
            const isMultiBar = _.isObject(yAxisSampleData) && yAxisField?.type !== 'customized';
            const isCustomized = yAxisField?.type === 'customized';

            if (isMultiBar) {
                aggregatedRow[graphYAxisKey] = _.reduce(group, (acc, currentItem) => {
                    const currentYObject = _.get(currentItem, graphYAxisKey);
                    _.forEach(currentYObject, (val, subKey) => {
                        const primitiveVal = _.isObject(val) && val.hasOwnProperty('data') ? val.data : val;
                        acc[subKey] = (acc[subKey] || 0) + (Number(primitiveVal) || 0);
                    });
                    return acc;
                }, {});
            } else if (isCustomized) {
                const sum = _.sumBy(group, item => Number(_.get(item, `${graphYAxisKey}.data`) || 0));
                aggregatedRow[graphYAxisKey] = { ...yAxisSampleData, data: sum };
            } else {
                const sum = _.sumBy(group, item => Number(_.get(item, graphYAxisKey) || 0));
                aggregatedRow[graphYAxisKey] = sum;
            }
            return aggregatedRow;
        });

        const xAxisField = listFields.find(f => f.path === graphXAxisKey);
        const yAxisDataForCheck = chartData[0] ? _.get(chartData[0], graphYAxisKey) : {};
        const isMultiBarForRender = _.isObject(yAxisDataForCheck) && yAxisField?.type !== 'customized';
        const isCustomizedForRender = yAxisField?.type === 'customized';

        const colors = ["#8884d8", "#82ca9d", "#ffc658", "#ff8042", "#0088FE", "#00C49F"];
        const chartHeight = graphHeight || 400;

        const series = isMultiBarForRender
            ? Object.keys(yAxisDataForCheck).map((key, index) => {
                if (graphType === 'linechart') {
                    return <Line
                        key={key}
                        type="monotone"
                        dataKey={`${graphYAxisKey}.${key}`}
                        stroke={colors[index % colors.length]}
                        name={t(key)}
                    />
                }
                return <Bar
                    key={key}
                    dataKey={`${graphYAxisKey}.${key}`}
                    fill={colors[index % colors.length]}
                    name={t(key)}
                />
            })
            : (() => {
                if (graphType === 'linechart') {
                    return <Line
                        type="monotone"
                        dataKey={isCustomizedForRender ? (payload) => _.get(payload, `${graphYAxisKey}.data`) : graphYAxisKey}
                        stroke={colors[0]}
                        name={yAxisField ? t(yAxisField.tKey) : graphYAxisKey}
                    />
                }
                return <Bar
                    dataKey={isCustomizedForRender ? (payload) => _.get(payload, `${graphYAxisKey}.data`) : graphYAxisKey}
                    fill={colors[0]}
                    name={yAxisField ? t(yAxisField.tKey) : graphYAxisKey}
                />
            })()

        const ChartComponent = graphType === 'linechart' ? LineChart : BarChart;


        return (
            <div className={field.applyBoard ? "DtObjectsComponent-container-withBoard" : "DtObjectsComponent-container"} style={{ height: chartHeight, width: '100%'}}>
                <ResponsiveContainer>
                    <ChartComponent data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey={graphXAxisKey} name={xAxisField ? t(xAxisField.tKey) : graphXAxisKey} />
                        <YAxis />
                        <Tooltip />
                        <Legend verticalAlign="top" wrapperStyle={{ paddingBottom: '20px' }} />
                        {series}
                    </ChartComponent>
                </ResponsiveContainer>
            </div>
        );
    }


    render() {
        const {
            input: { value },
            meta:{ touched, error },
            field,
            listFields,
            module,
            t,
            language,
            path,
            required,
            disabled,
            displayTooltip,
            exportTableObject
        } = this.props

        const translatedError = t(error)

        const cellDataGetterForField = makeDataGetter({ language, t })

        const visibleMap = this.state.selectorOptions.reduce(
            (acc, column) => Object.assign(acc, { [column.key]: column.selected }),
            {}
        )

        const selectedColumns = listFields.filter(
            field => visibleMap[field.path]
        )

        if(field.parentHeader) {
            selectedColumns.sort((a, b) => {
                if(!a.parentColumn) a.parentColumn = ""
                if(!b.parentColumn) b.parentColumn = ""
                // Group by parentColumn
                if (a.parentColumn < b.parentColumn) return -1
                if (a.parentColumn > b.parentColumn) return 1

                // If parentColumn is the same, sort by another attribute, for example, id
                if (a.order < b.order) return -1
                if (a.order > b.order) return 1

                return 0
            })
        }

        const enhancedColumns = selectedColumns.map((field) => {
            return {
                ...field,
                dataKey: field.path,
                label: t(field.tKey),
                dataGetter: cellDataGetterForField(field)
            }
        })

        const filteredObjects = applyFilter({
            objects: value,
            filter: this.state.filter,
            columns: enhancedColumns
        })

        const sortedObjects = field.sortable
            ? applySort({
                objects: filteredObjects,
                sortBy: this.state.sortBy,
                sortDirection: this.state.sortDirection,
                columns: enhancedColumns
            })
            : filteredObjects


        const rowRenderer = (object) => {

            const displayRow = defaultRowRenderer({...object, style: {...object.style, ...object.rowData.style}})


            const values = selectedColumns.map(
                column => {
                    return <div>
                        <div>{t(column.tKey)}</div>
                        <strong>{object.rowData[column.path]}</strong>
                        <br/>
                        <br/>
                    </div>
                }
            )

            return displayTooltip
                ? (
                    <HoverPopover
                        key={object.rowData.id}
                        id={'comment-popover'}
                        message={
                            <div>
                                {values}
                            </div>
                        }
                        placement={'top'}
                    >
                        {displayRow}
                    </HoverPopover>
                )
                : displayRow
        }

        return (
            <div style={{padding: '5px'}}>
                <label className="DtObjectsComponent-label" >{t(path)} {required && '*'}</label>

                {(this.state.viewMode === 'table' || !field.graphViewEnabled)
                    ? (<div style={{border: field.applyBoard ? '1px solid #ddd' : 'none', borderRadius: field.applyBoard ? '4px': ''}}>
                        {
                            field.applyBoard && (
                                <div className="DtObjectsComponent-Board">
                                    <div className="DtObjectsComponent-Board-left">
                                        <ColumnSelector
                                            options={this.state.selectorOptions}
                                            opened={this.state.columnSelectorOpened}
                                            open={this.handleOpenColumnSelector.bind(this)}
                                            changeColumnSelection={this.handleChangeColumnSelection.bind(this)}
                                            t={t}
                                        />
                                        <DownloadDataTable
                                            objects={sortedObjects}
                                            columns={enhancedColumns}
                                            filename={t(module.tKey)}
                                            exportTableObject={exportTableObject}
                                        />
                                    </div>
                                    <div className="DtObjectsComponent-Board-right">
                                        {this.state.isSearchActive && (
                                            <span className="DataTable-Board-count">
                                                {sortedObjects?.length} {sortedObjects?.length === 1 ? t("element") : t("elements")}
                                            </span>
                                        )}
                                        <DataTableFilter
                                            value={this.state.filter}
                                            onChange={this.changeFilter.bind(this)}
                                            onFocus={() => this.setState({isSearchActive: true})}
                                            onBlur={() => {
                                                if (!this.state.filter) {
                                                    this.setState({isSearchActive: false})
                                                }
                                            }}
                                            placeholder={`${t('search')}...`}
                                        />
                                        {field.graphViewEnabled && (
                                            <div style={{ marginLeft: '10px' }}>
                                                <button
                                                    style={{ padding: '5px', marginRight: '5px', cursor: 'pointer', background: this.state.viewMode === 'table' ? '#e0e0e0' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}
                                                    onClick={() => this.setState({ viewMode: 'table' })}
                                                >
                                                    <TableIcon size={18} />
                                                </button>
                                                <button
                                                    style={{ padding: '5px', cursor: 'pointer', background: this.state.viewMode === 'graph' ? '#e0e0e0' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}
                                                    onClick={() => this.setState({ viewMode: 'graph' })}
                                                >
                                                    <AreaChart size={18} />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        }
                        <div className={field.applyBoard ? "DtObjectsComponent-container-withBoard" : "DtObjectsComponent-container"}>
                            <AutoSizer disableHeight>
                                {({ width }) => (
                                    <Table
                                        objects={sortedObjects}
                                        gridClassName={'DtObjectsComponent-innerGrid'}
                                        headerHeight={field.headerHeight}
                                        disableHeader={field.disableHeader}
                                        headerClassName={field.headerClassName}
                                        headerRowRenderer={props => this.headerRenderer(props, selectedColumns, field.parentHeader)}
                                        width={width}
                                        height={this.getHeight(sortedObjects)}
                                        autoGrow={field.autoGrow}
                                        maxRows={field.maxRows}
                                        noHover={field.noHover}
                                        noRowsLabel={t(field.noRowsMessage || t('noRows'))}
                                        rowRenderer={rowRenderer}
                                        sort={({ sortBy, sortDirection }) => {
                                            if(field.sortable) {
                                                this.setState({
                                                    sortBy,
                                                    sortDirection
                                                })
                                            }
                                        }}
                                        sortBy={this.state.sortBy}
                                        sortDirection={this.state.sortDirection}
                                    >
                                        {enhancedColumns.map((listField, index) => {
                                            const nextColumn = selectedColumns[index + 1]
                                            return (
                                                <Column
                                                    {...listField}
                                                    headerRenderer={this.renderColumnHeader(listField, nextColumn, sortedObjects, this.onRowChange)}
                                                    key={listField.id}
                                                    flexGrow={1}
                                                    width={listField.width || 200}
                                                    dataKey={listField.path}
                                                    label={t(listField.tKey)}
                                                    cellDataGetter={({ rowData }) => cellDataGetterForField(listField)(rowData)}
                                                    cellRenderer={this.cellRenderer(sortedObjects, listField, this.onRowChange, disabled)}
                                                    className={listField.className}
                                                    style={listField.style}
                                                />
                                            )
                                        })}
                                    </Table>
                                )}
                            </AutoSizer>
                        </div>
                        {touched && error && <ValidationUI error={translatedError}/>}
                    </div>)
                    :
                    <div style={{border: field.applyBoard ? '1px solid #ddd' : 'none', borderRadius: field.applyBoard ? '4px': ''}}>
                        <div className="DtObjectsComponent-Board">
                            <div className="DtObjectsComponent-Board-left">
                                <div style={{ display: 'flex' }}>
                                    <button
                                        style={{ padding: '5px', marginRight: '5px', cursor: 'pointer', background: this.state.graphType === 'barchart' ? '#e0e0e0' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}
                                        onClick={() => this.setState({ graphType: 'barchart' })}
                                    >
                                        <BarChartIcon size={18} />
                                    </button>
                                    <button
                                        style={{ padding: '5px', cursor: 'pointer', background: this.state.graphType === 'linechart' ? '#e0e0e0' : 'white', border: '1px solid #ccc', borderRadius: '4px' }}
                                        onClick={() => this.setState({ graphType: 'linechart' })}
                                    >
                                        <LineChartIcon size={18} />
                                    </button>
                                </div>
                            </div>
                            <div className="DtObjectsComponent-Board-right">
                                {field.graphViewEnabled && (
                                    <div style={{marginLeft: '10px'}}>
                                        <button
                                            style={{
                                                padding: '5px',
                                                marginRight: '5px',
                                                cursor: 'pointer',
                                                background: this.state.viewMode === 'table' ? '#e0e0e0' : 'white',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px'
                                            }}
                                            onClick={() => this.setState({viewMode: 'table'})}
                                        >
                                            <TableIcon size={18} />
                                        </button>
                                        <button
                                            style={{
                                                padding: '5px',
                                                cursor: 'pointer',
                                                background: this.state.viewMode === 'graph' ? '#e0e0e0' : 'white',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px'
                                            }}
                                            onClick={() => this.setState({viewMode: 'graph'})}
                                        >
                                            <AreaChart size={18} />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        {this.renderGraphView(sortedObjects)}
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    startDateById: getEditStartDateById(state),
    endDateById: getEditEndDateById(state)
})

const mapDispatchToProps = {
    toggleCalendar,
    setFieldWidth
}

export default connect(mapStateToProps, mapDispatchToProps)(DtObjectsComponent)
